import { ProductSize } from '../interfaces/Order';

const PREDEFINED_COLORS = [
  { name: 'Trắng', hex: '#FFFFFF' },
  { name: 'Đen', hex: '#000000' },
  { name: 'Xanh navy', hex: '#000080' },
  { name: 'Be', hex: '#F5F5DC' },
  { name: 'Xám', hex: '#808080' },
  { name: 'Đỏ', hex: '#FF0000' },
  { name: 'Xanh dương', hex: '#0000FF' },
  { name: 'Xanh lá', hex: '#008000' },
  { name: 'Vàng', hex: '#FFFF00' },
  { name: 'Hồng', hex: '#FFC0CB' },
  { name: 'Tím', hex: '#800080' },
  { name: 'Cam', hex: '#FFA500' },
];

const TSHIRT_SIZES = [
  ProductSize.S,
  ProductSize.M,
  ProductSize.L,
  ProductSize.XL,
  ProductSize.XXL,
  ProductSize.XXXL,
];

const BAG_SIZES = [ProductSize.BAG_WITH_LOCK, ProductSize.BAG_WITHOUT_LOCK];

interface NewVariant {
  size: ProductSize;
  price: number;
  stockQuantity: number;
  tempId: string;
}

export { BAG_SIZES, PREDEFINED_COLORS, TSHIRT_SIZES, type NewVariant };
